import axios from 'axios';
import { Button, message, Page, Row, Text, Space } from 'components';
import { AuthContext } from 'contexts';
import React from 'react';
import styled from 'styled-components';

import { Loading } from '@app/react-common';
import { Input } from 'components/Input';

const API_URL = '/listing/duplicates/qa_page/process';

const ProcessDuplicatesPage = () => {
  const { auth } = React.useContext(AuthContext);
  const [orgIdInput, setOrgIdInput] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [result, setResult] = React.useState('');

  const performAction = async (cb: () => Promise<void>) => {
    try {
      setResult('');
      setIsLoading(true);
      await cb();
      setResult('Done!');
    } catch (err) {
      setResult(err.toString());
    } finally {
      setIsLoading(false);
    }
  };

  const processDuplicates = () => {
    performAction(async () => {
      await axios.post(API_URL, { orgId: orgIdInput });
    });
  };

  if (isLoading) return <Loading />;

  return (
    <Page type="filled" title="Process Listing Duplicates QA Page">
      <Layout>
        <Text>
          This will trigger the cron job responsible for suggesting duplicate
          listings to merge or combine.
        </Text>
        <Row>
          <Input
            placeholder="Default as BrokerBay"
            width="400px"
            onChange={e => setOrgIdInput(e.target.value)}
          />
          <Button onClick={processDuplicates}>Find Duplicates!</Button>
        </Row>
        {result && <Text>{result}</Text>}
      </Layout>
    </Page>
  );
};

export default ProcessDuplicatesPage;

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 10px;
  padding: 20px;
  background: white;
`;
